import request from '@onefootprint/request';
import type { Organization } from '@onefootprint/request-types/dashboard';
import { useQuery } from '@tanstack/react-query';
import { DASHBOARD_AUTHORIZATION_HEADER } from '@/config/constants';

const getAuthRoles = async ({ authToken }: { authToken: string }) => {
  const { data } = await request<Organization[]>({
    method: 'GET',
    url: '/org/auth/roles',
    headers: {
      [DASHBOARD_AUTHORIZATION_HEADER]: authToken,
    },
  });

  return data;
};

const useAuthRoles = (authToken: string) =>
  useQuery({
    queryKey: ['get-roles', authToken],
    queryFn: () => getAuthRoles({ authToken }),
    enabled: !!authToken,
  });

export default useAuthRoles;
